var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / hotel_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707784",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E535C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-hotel_gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,19.2 C2.13149414,19.2 2.4,18.9314941 2.4,18.6 L2.4,16.8 L21.6,16.8 L21.6,18.6 C21.6,18.9314941 21.8685059,19.2 22.2,19.2 L23.4,19.2 C23.7314941,19.2 24,18.9314941 24,18.6 L24,11.4 C24,9.08023682 22.1197632,7.2 19.8,7.2 L11.4,7.2 C11.0685059,7.2 10.8,7.46850586 10.8,7.8 L10.8,13.2 L2.4,13.2 L2.4,5.4 C2.4,5.06850586 2.13149414,4.8 1.8,4.8 L0.6,4.8 C0.268505859,4.8 0,5.06850586 0,5.4 L0,18.6 C0,18.9314941 0.268505859,19.2 0.6,19.2 L1.8,19.2 Z M6.6,12 C8.25413818,12 9.6,10.6541382 9.6,9 C9.6,7.34586182 8.25413818,6 6.6,6 C4.94586182,6 3.6,7.34586182 3.6,9 C3.6,10.6541382 4.94586182,12 6.6,12 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelGray);
export default __webpack_public_path__ + "static/media/hotel_gray.b9bb6194c897502e15cdf6079d6a7d43.svg";
export { ForwardRef as ReactComponent };